import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import ProductCard from "../../components/ProductCard/ProductCard";
import "./products.scss";
import { PRODUCTTYPELIST, ProductList } from "api/Constants";
import { APICALL } from "api/ApiCall";
/////
import Sidebar from "../../components/Sidebar/Sidebar";
import PageName from "../../components/PageName/PageName";
import { HOME } from "api/Constants";
import { getLanguageId } from "api/Utils";

const Products = () => {
  const [sideBarData, setSidebarData] = React.useState([]);
  const [ProductListData, setProductListData] = React.useState([]);
  const [nextText, setnextText] = React.useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProductList();
    fetchNextText();
  }, []);

  const fetchProductList = async () => {
    const languageId = localStorage.getItem("languageId");
    const productListData = await APICALL(PRODUCTTYPELIST, [
      { name: "languageId", value: getLanguageId() },
    ]);
    if (!productListData.data) return alert("No Data Found");
    let customizeProducts =
      productListData &&
      productListData.data.map((e) => {
        let dt = {
          ...e,
          name: e.ProductTypeName,
          image: e.ImgPath,
          id: e.ProductTypeId,
        };
        return dt;
      });
    setProductListData(customizeProducts);
  };

  const fetchNextText = async () => {
    const languageId = localStorage.getItem("languageId");
    const dashboardData = await APICALL(HOME, [
      { name: "languageId", value: getLanguageId() },
    ]);
    setnextText(dashboardData.Next);
  };

  const handlerItemClick = (data, sideBarItem = false) => {
    const { ProductTypeId = null, isSubCategory = 0 } = data;
    if (isSubCategory == 1) {
      window.location.href = `/ProductsSubCat?id=${ProductTypeId}`;
    } else {
      window.location.href = `/ProductSubChildCategory?id=${ProductTypeId}_${0}`;
    }
  };
  const languageId = localStorage.getItem("languageId");
  let convertLanVal = languageId.replace(/'/g, " ").trim();
  return (
    <div>
      <PageName
        name="Products"
        type={1}
        //selectedBread={(data) => this.goToBread(data)}
      /> 
      <div className="productsPage">
        <Sidebar type={1} />
        <div className="productsList">
          <div className="titleName">
            {convertLanVal == 1
              ? "सभी उत्पाद श्रेणियाँ"
              : "All Product Categories"}
          </div>
          <div className="allProductsCards">
            {ProductListData.map((e, index) => (
              <ProductCard
                key={index}
                data={e}
                handleClick={(data) => handlerItemClick(data)}
                nextText={nextText}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
